import React, { useEffect, useState } from 'react';
import { List } from '@fluentui/react/lib/List';
import { Shimmer, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import CommunityMemberPersona from '../CommunityMemberPersona';

const CommunityOwnersComponent = (props: any) => {
  const [expand, setExpand] = useState<boolean>(false);
  const { membersActionCreators, community, items, profile, brandName } = props;

  useEffect(() => {
    console.log('owner comp loaded', community?.communityId);
    if ( community?.communityId )
      membersActionCreators.requestFetchMembersByRole(community.communityId, 'owner');
  }, [community?.communityId]);

  const onRenderCell = (item) => {
    return (
      <CommunityMemberPersona
        className='communityOwners-item'
        item={item}
        directionalHint={DirectionalHint.leftCenter}
        community={community}
        profile={profile}
        brandName={brandName}
      />
    );
  };

  return (
    <Shimmer
      width={'100%'}
      styles={{
        root: {
          marginTop: 20,
          marginBottom: 30
        }
      }}
      isDataLoaded={items !== null}
      shimmerElements={[
        { type: ShimmerElementType.circle, width: 72, height: 72 },
        { type: ShimmerElementType.gap, width: 16 },
        { type: ShimmerElementType.line, height: 60 }
      ]}
    >
      <div className={`communityOwners ${expand ? 'expand' : ''}`}>
        <List
          className='communityOwners-list'
          items={items}
          onRenderCell={onRenderCell}
        />
      </div>
      {items && items.length > 3 && (
        <DefaultButton
          styles={{
            root: {
              marginTop: 15
            }
          }}
          text={!expand ? 'Show all' : 'Show less'}
          iconProps={{
            iconName: !expand ? 'ChevronDown' : 'ChevronUp'
          }}
          className='communityOwners-button'
          onClick={(ev) => {
            setExpand(prev => !prev);
            ev.preventDefault();
            ev.stopPropagation();
          }}
        />
      )}
    </Shimmer>
  );
};

export default CommunityOwnersComponent;